document.addEventListener('alpine:init', () => {
  Alpine.data('universalSlider', () => ({
    sliderEl: document.createElement('div'),

    init() {
      if (!window.wp) {
        this.sliderEl.classList.add(
          'swiper-container',
          'w-full',
          '-my-10',
          'py-10',
          'px-[Max(144px,calc((100%-1639px)/2+144px))]',
          'tl:px-[Max(24px,calc((100%-1639px)/2+24px))]',
          'overflow-hidden'
        );

        const innerBlocks = this.$root.querySelector('[data-inner-blocks]');
        const children = [...innerBlocks.children];
        const wrapper = document.createElement('div');
        wrapper.classList.add('swiper-wrapper');

        children.forEach((child) => {
          const slide = document.createElement('div');
          slide.classList.add('swiper-slide', 'w-[360px]', 'ph:w-[316px]');
          slide.append(child);
          wrapper.append(slide);
        });

        this.sliderEl.append(wrapper);
        innerBlocks.append(this.sliderEl);

        setTimeout(() => this.initSwiper());
      }
    },

    initSwiper() {
      new Swiper(this.sliderEl, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        centeredSlides: true,
        centeredSlidesBounds: true,
        centerInsufficientSlides: true,
        breakpoints: {
          769: {
            spaceBetween: 32,
            centeredSlides: false,
            centeredSlidesBounds: false,
          },
        },
        keyboard: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        pagination: {
          el: this.$root.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    },
  }));
});